import InviteOrgContractCompletePage from "./InviteOrgContractCompletePage";

export default InviteOrgContractCompletePage;
